import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { DC_195, P107_2, VP_077, VP_140, VP_141 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity } from 'rpqs/utils/RPQSUtils'
import { round } from 'lodash'

const DialogP107_2 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        rpqs,
        managementEntity,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntityDialog] = useState(managementEntity)

    useEffect(() => {
        setEntityDialog(managementEntity)
    }, [managementEntity])

    const year = rpqs.year
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const formatedIndicators = [
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: DC_195.code,
            indicatorName: i18n[DC_195.i18n],
            unit: i18n.excludingTaxEuro,
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, DC_195.code,
                { ...currentEntity?.[DC_195.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_077.code,
            indicatorName: i18n[VP_077.i18n],
            unit: 'km',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_077.code,
                { ...currentEntity?.[VP_077.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_140.code,
            indicatorName: i18n[VP_140.i18n],
            unit: 'km',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_140.code,
                { ...currentEntity?.[VP_140.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_141.code,
            indicatorName: i18n[VP_141.i18n],
            unit: 'km',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_141.code,
                { ...currentEntity?.[VP_141.code], value: parseInt(v) || 0 },
            ))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P107_2.code, { ...currentEntity?.[P107_2.code], status }))
    }

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    const calculation = () => {
        const calculatedValue = getIndicatorValue(VP_077) > 0 ? round(((getIndicatorValue(VP_140) + getIndicatorValue(VP_141)) / 5) / getIndicatorValue(VP_077) / 100, 2) : 0

        return updateIndicatorEntity(entityDialog, year, P107_2.code, { ...currentEntity?.[P107_2.code], value: calculatedValue })
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntityDialog}
            codeIndicator={P107_2.code}
            calculationOnRegister={calculation}
        >
            <Grid container direction={'column'} gap={2}>
                <IndicatorHeaderDialog
                    current={{
                        year,
                        value: managementEntity?.[year]?.[P107_2.code]?.value,
                    }}
                    previous={{
                        year: previousYear,
                        value: managementEntity?.[previousYear]?.[P107_2.code]?.value,
                    }}
                    status={entityDialog?.[year]?.[P107_2.code]?.status}
                    onStatusChange={onStatusChange}
                    unit={'%'}
                />
                <Divider/>
                <IndicatorTable
                    year={year?.toString()}
                    indicators={formatedIndicators}
                />

            </Grid>
        </EntityIndicatorDialog>
    )
}

DialogP107_2.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP107_2
